import { render, staticRenderFns } from "./Stu_Mingye.vue?vue&type=template&id=168913f2&scoped=true"
import script from "./Stu_Mingye.vue?vue&type=script&lang=js"
export * from "./Stu_Mingye.vue?vue&type=script&lang=js"
import style0 from "./Stu_Mingye.vue?vue&type=style&index=0&id=168913f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168913f2",
  null
  
)

export default component.exports